import { render, staticRenderFns } from "./work_items_create_saved_view_dropdown.vue.js?vue&type=template&id=6d7a6d87&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_items_create_saved_view_dropdown.vue?vue&type=template&id=6d7a6d87&vue3"
import script from "./work_items_create_saved_view_dropdown.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_items_create_saved_view_dropdown.vue?vue&type=script&lang=js&vue3"
export * from "./work_items_create_saved_view_dropdown.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_items_create_saved_view_dropdown.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports